"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";
import { useEffect, useRef, useState } from "react";

export function ExploreBanner({ type, collapsed = false }) {
  const router = useRouter();
  const [isExpanded, setIsExpanded] = useState(!collapsed);
  const prevCollapsed = useRef(collapsed);
  const handleClick = () => {
    router.push("/explore-agents");
  };

  useEffect(() => {
    if (!collapsed) {
      setIsExpanded(true);
    } else if (prevCollapsed.current !== collapsed) {
      setIsExpanded(false);
    }
    prevCollapsed.current = collapsed;
  }, [collapsed]);

  if (collapsed && !isExpanded) {
    return (
      <button
        type="button"
        onClick={() => setIsExpanded(true)}
        className="fixed right-4 top-20 z-40 h-10 w-10 rounded-full border border-white/10 bg-black/70 text-white shadow-lg backdrop-blur flex items-center justify-center hover:bg-white hover:text-black transition-colors max-sm:top-[60px] border border-[#c3aa20]"
        aria-label="Explore examples"
        title="Explore examples"
      >
        <Image
          src="/images/sparkles.png"
          alt="Explore"
          width={16}
          height={16}
          className="h-4 w-4 object-contain"
        />
      </button>
    );
  }

  return (
    <div
      className={
        collapsed
          ? "fixed left-1/2 top-20 z-40 w-[min(760px,calc(100%-32px))] -translate-x-1/2"
          : "relative w-full"
      }
    >
      <div 
      className="relative w-full flex gap-3 rounded-2xl border border-white/10 bg-black/80 text-white backdrop-blur py-4 md:px-6 px-4 shadow-xl"
      onClick={handleClick} 
      >
        <figure className="h-7 w-7 block">
          <Image
            src="/images/sparkles.png"
            alt="Sparkle"
            width={20}
            height={28}
            className="w-full h-full object-contain"
          />
        </figure>
        <div className="flex-1">
          <h3 className="font-semibold text-sm text-white">Explore More AI Agents</h3>
          <p className="text-sm text-white/70">
            Create websites, redesign layouts, generate cards, write policies, translate content, and manage business tasks — no coding required.
          </p>
        </div>
        <button
          // onClick={handleClick}
          type="button"
          className="h-9 w-9 border border-white/20 rounded-full flex items-center justify-center absolute top-[50%] md:right-2 right-2 -translate-y-[50%] p-2 hover:bg-white hover:text-black transition-colors max-sm:top-[22px] border-[0px]"
          aria-label="Explore examples"
          title="Explore examples"
        >
          <svg
            height="14"
            strokeLinejoin="round"
            viewBox="0 0 16 16"
            width="14"
            style={{ color: "currentColor" }}
            className="rotate-[45deg] w-full h-full"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.70711 1.39644C8.31659 1.00592 7.68342 1.00592 7.2929 1.39644L2.21968 6.46966L1.68935 6.99999L2.75001 8.06065L3.28034 7.53032L7.25001 3.56065V14.25V15H8.75001V14.25V3.56065L12.7197 7.53032L13.25 8.06065L14.3107 6.99999L13.7803 6.46966L8.70711 1.39644Z"
              fill="currentColor"
            ></path>
          </svg>
        </button>
        {collapsed && (
          <button
            type="button"
            onClick={() => setIsExpanded(false)}
            className="absolute -top-1.5 -right-1.5 h-6 w-6 rounded-full border border-white/20 bg-black/80 text-xs text-white flex items-center justify-center hover:bg-white hover:text-black transition-colors"
            aria-label="Close"
            title="Close"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
}
